<div class="offcanvas offcanvas-start" tabindex="-1" id="pagerOffcanvas" aria-labelledby="pagerOffcanvasLabel"
    data-bs-backdrop="false" data-bs-scroll="true">
    <div class="offcanvas-body p-0 overflow-hidden h-100 w-100">
        <div class="d-flex h-100 w-100 overflow-hidden">

    <!-- Sidebar -->
    <div class="pager-sidebar flex-shrink-0" [class.show-mobile]="showMobileSidebar()"
        style="width: 300px; background-color: rgb(34, 34, 34)!important; border-right: 1px solid rgb(51,51,51)!important;">

        <div class="d-flex d-md-none justify-content-between align-items-center p-3 border-bottom border-dark" style="background-color: rgb(34, 34, 34);">
            <h5 class="fw-bold mb-0 text-white">Conversations</h5>
            <button type="button" class="btn-close btn-close-white" (click)="showMobileSidebar.set(false)" title="Close"></button>
        </div>

        <div class="p-0 h-100 overflow-auto">
            <div class="w-100 p-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="text-uppercase small fw-bold text-secondary mb-0">CONVERSATIONS - {{
                        conversations().length }}</h6>
                </div>
                @if(conversations().length > 0) {
                <ul class="list-unstyled flex-grow-1 overflow-auto" role="list">
                    @for(conversation of conversations(); track $index) {
                    <div class="position-relative conversation-item">
                        <app-player-panel [player]="conversation.friend"
                            (click)="select(conversation)"></app-player-panel>
                        <button type="button"
                            class="btn btn-close-conv btn-link text-secondary position-absolute top-50 end-0 translate-middle-y me-3 p-0"
                            (click)="close($event, conversation.friendUserId)" title="Close Conversation"
                            style="border: none; background: none; z-index: 10;">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </div>
                    }
                </ul>
                }@else {
                <div class="w-100 text-center pt-3">
                    <p class="text-muted">
                        No current conversations.
                    </p>
                </div>
                }
            </div>
        </div>
    </div>

    <!-- Main -->
    <div class="flex-grow-1 d-flex flex-column min-w-0" style="min-height: 0;background-color: rgb(42,42,46);">

        @if(selectedConversation() != null){
        <!-- Header -->
        <div class="p-3 flex-shrink-0 d-flex justify-content-between align-items-center"
            style="border-bottom: 1px solid rgb(5,51,51);background-color: rgb(34,34,34);">
            <div class="d-flex align-items-center gap-3 ms-2">
                <h4 class="fw-bold mb-0 text-truncate">
                    {{selectedConversation()?.friend!.userName}}
                </h4>
                <div class="d-flex align-items-center gap-2 px-2 py-1 rounded"
                    style="background-color: rgba(0, 0, 0, 0.25);">
                    <span class="status-dot"
                        [class]="'status-dot-' + getStatusText(selectedConversation()?.friend!.status)"
                        style="position: static; display: inline-block; width: 8px; height: 8px; border: none;"></span>
                    <small [class]="getStatusColor(selectedConversation()?.friend!.status)"
                        style="font-size: 0.75rem; text-transform: capitalize; font-weight: 500;">
                        {{ getStatusText(selectedConversation()?.friend!.status) }}
                    </small>
                </div>
            </div>

            <div class="d-flex align-items-center gap-2">
                <button class="btn btn-dark d-md-none" type="button" (click)="showMobileSidebar.set(true)"
                    title="Show Conversations">
                    <i class="bi bi-people-fill"></i>
                </button>
                <button class="btn btn-outline-secondary border-0 p-2 text-secondary hover-white" type="button"
                    data-bs-dismiss="offcanvas" aria-label="Close Pager" title="Close Pager">
                    <i class="bi bi-x-lg fs-5"></i>
                </button>
            </div>
        </div>

        <!-- Scrollable content -->
        <div class="chat-messages position-relative flex-grow-1 overflow-auto" style="min-height: 0;" #msgEl>
            <div class="w-100 p-3">
                @for(message of selectedConversation().messages; track message) {
                <app-message [message]="message"></app-message>
                }
            </div>
            <div #bottomAnchor></div>

            @if(showCelebration()) {
            <div class="celebration-container">
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
            </div>
            }

            @if(showBirthday()) {
            <div class="birthday-container">
                <div class="cake-wrapper">
                    <div class="candle">
                        <div class="flame"></div>
                    </div>
                    <div class="cake-layer layer-top"></div>
                    <div class="cake-layer layer-middle"></div>
                    <div class="cake-layer layer-bottom"></div>
                </div>
            </div>
            }

            @if(showSnow()) {
            <div class="snow-container">
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
            </div>
            }

            @if(showFireworks()) {
            <div class="fireworks-container">
                <div class="firework firework-1">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-2">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-3">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-4">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-5">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="chat-input-wrapper p-3 position-relative">
            @if(showGiphy()) {
            <div class="giphy-popup position-absolute bottom-100 start-0 m-2 mb-2 p-3 bg-dark border border-secondary rounded shadow-lg"
                style="width: 400px; height: 500px; z-index: 1000;">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0 text-white">Search GIPHY</h6>
                    <button type="button" class="btn-close btn-close-white" (click)="showGiphy.set(false)"></button>
                </div>
                <input type="text" class="form-control mb-3 bg-black text-white border-secondary"
                    placeholder="Search GIFs..." #giphySearchBox (input)="giphySearch(giphySearchBox.value)">
                <div class="giphy-results overflow-auto" style="height: calc(100% - 100px);">
                    <div class="row g-2">
                        @for(gif of giphy.searchResults(); track gif.id) {
                        <div class="col-4">
                            <img [src]="gif.images.fixed_height_small.url"
                                class="img-fluid rounded cursor-pointer hover-opacity" [alt]="gif.title"
                                (click)="selectGif(gif)">
                        </div>
                        }
                        @if(giphy.searchResults().length === 0) {
                        <div class="col-12 text-center text-muted mt-5">
                            <i class="bi bi-search fs-1"></i>
                            <p>Search for something cool!</p>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
            @if(showEmoji()) {
            <app-emoji-picker class="emoji-popup position-absolute bottom-100 end-0 m-2 mb-2"
                (selectEmoji)="insertEmoji($event, messageBox)" (closePicker)="showEmoji.set(false)">
            </app-emoji-picker>
            }
            <div class="input-group">
                <input type="text" class="form-control chat-input p-3 border-0"
                    placeholder="Message {{ selectedConversation()?.friend!.userName }}" name="newMessage"
                    [ngModel]="newMessage()" (ngModelChange)="newMessage.set($event)"
                    (keydown.enter)="send(messageBox.value); messageBox.value = ''; newMessage.set('')" #messageBox>
                <button type="button" class="btn btn-dark border-0 px-3 d-flex align-items-center"
                    (click)="$event.stopPropagation(); toggleEmoji()" title="Emoji">
                    <i class="bi bi-emoji-smile fs-5"></i>
                </button>
                <button type="button" class="btn btn-dark border-0 px-3 d-flex align-items-center"
                    (click)="toggleGiphy()" title="GIPHY">
                    <i class="bi bi-file-earmark-image fs-5"></i>
                </button>
            </div>
        </div>
        }@else {
        <!-- Header for empty state -->
        <div class="p-3 flex-shrink-0 d-flex justify-content-between align-items-center"
            style="border-bottom: 1px solid rgb(5,51,51);background-color: rgb(34,34,34);">
            <div class="d-flex align-items-center gap-3 ms-2">
                <h4 class="fw-bold mb-0 text-truncate text-white">
                    Messages
                </h4>
            </div>

            <div class="d-flex align-items-center gap-2">
                <button class="btn btn-dark d-md-none" type="button" (click)="showMobileSidebar.set(true)"
                    title="Show Conversations">
                    <i class="bi bi-people-fill"></i>
                </button>
                <button class="btn btn-outline-secondary border-0 p-2 text-secondary hover-white" type="button" 
                    data-bs-dismiss="offcanvas" aria-label="Close Pager" title="Close Pager">
                    <i class="bi bi-x-lg fs-5"></i>
                </button>
            </div>
        </div>

        <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-4">
            <p class="text-muted mb-3">Please select or start a conversation.</p>
            <button class="btn btn-outline-primary d-md-none px-4 rounded-pill" type="button" 
                (click)="showMobileSidebar.set(true)">
                <i class="bi bi-chat-left-text me-2"></i> View Conversations
            </button>
        </div>
        }

    </div>

        </div>
    </div>
</div>
<app-external-link-modal></app-external-link-modal>